import React from "react";

import { ExampleForm } from "./";

const ExamplePage = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1>Example Page</h1>
        <ExampleForm
          onSubmit={() => null}
          initialValues={{
            textInput: "test",
            names: [
              { aaa: "test1", bbb: "test2" },
              { aaa: "test3", bbb: "test4" },
            ],
          }}
        />
      </div>
    </div>
  );
};

export default ExamplePage;



// WEBPACK FOOTER //
// ./src/components/example/ExamplePage.js